export const githubLink = "https://github.com/moates695";
export const finskaGithubLink = "https://github.com/moates695/finska";
export const balderdashGithubLink = "https://github.com/moates695/balderdash";
export const expoLink = "https://expo.dev/accounts/moates";
export const finskaExpoLink = "https://expo.dev/accounts/moates/projects/finska";
export const gymJunkiePlayStoreLink = "https://play.google.com/store/apps/details?id=au.com.moates.gymjunkie&hl=en";
export const gymJunkieAppStoreLink = "https://apps.apple.com/au/app/gym-junkie/id6769685454";
export const woodchuckPlayStoreLink = "https://play.google.com/store/apps/details?id=au.com.moates.woodchuck&hl=en";
export const pypiLink = "https://pypi.org/user/moates/";
export const downerhelperLink = "https://pypi.org/project/downerhelper/"
export const stravaLink = "https://www.strava.com/athletes/46665081"
export const cellularTrackingGithubLink = "https://github.com/moates695/cs9517_Group_Project"
export const postgresDeployLink = "https://pypi.org/project/postgresdeploy/"
export const imaxBotGithubLink = "https://github.com/moates695/imax_bot"
export const mcpServerGithubLink = "https://github.com/moates695/moates_mcp"
export const secretsVaultGithubLink = "https://github.com/moates695/secrets_vault"
export const vsCodeExtensionsGithubLink = "https://github.com/moates695/vs_code_extensions"
export const garminWatchfaceGithubLink = "https://github.com/moates695/garmin-watchface"
export const smartTrainerGithubLink = "https://github.com/moates695/cycling_smart_trainer"
export const smartTrainerLiveLink = "https://watts.moates.com.au"
export const auukiLink = "https://auuki.com"
export const auukiUpstreamLink = "https://github.com/dvmarinoff/Auuki"
export const mcpServerEndpoint = "https://mcp.moates.com.au/mcp"
export const authenticatorGithubLink = "https://github.com/moates695/authenticator"
export const authenticatorPlayStoreLink = "https://play.google.com/store/apps/details?id=au.com.moates.authenticator_moates&hl=en";
export const eventPickerGithubLink = "https://github.com/moates695/event_picker"
// The public demo page. A real page on the live app, flagged so it never
// notifies and never shows one visitor's answer to the next.
export const eventPickerDemoLink = "https://events.moates.com.au/e/tryevents/"
// Kaggle. The competition link is public; the profile link is filled in once
// the account URL is confirmed, and the page hides the profile button until then.
export const kaggleProfileLink = "";
export const kaggleCellTrackingLink =
  "https://www.kaggle.com/competitions/biohub-cell-tracking-during-development";
export const paypalLink = "https://paypal.me/moates695";